import { tosApi } from './tosApi';

export type VerifyCodeRequest = {
  challenge_id: string;
  code: string;
  trust_device: boolean;
};

export type VerifyCodeResponse = {
  access: string;
  refresh: string;
  user: any;
};

export type TrustedDevice = {
  id: number;
  device_name: string;
  ip_address: string;
  created_at: string;
  last_used_at: string;
  expires_at: string;
};

export type TrustedDevicesResponse = {
  devices: TrustedDevice[];
  trusted_devices_enabled: boolean;
  message?: string;
};

export const twoFactorApi = tosApi.injectEndpoints({
  endpoints: (builder) => ({
    verifyCode: builder.mutation<VerifyCodeResponse, VerifyCodeRequest>({
      query: (body) => ({
        url: '/core/auth/2fa/verify',
        method: 'POST',
        body,
      }),
    }),

    resendCode: builder.mutation<
      { challenge_id: string; message: string },
      { challenge_id: string }
    >({
      query: (body) => ({
        url: '/core/auth/2fa/resend',
        method: 'POST',
        body,
      }),
    }),

    getTrustedDevices: builder.query<TrustedDevicesResponse, void>({
      query: () => '/core/auth/2fa/devices',
      providesTags: ['TrustedDevices'],
    }),

    revokeDevice: builder.mutation<
      { success: boolean; message: string },
      number
    >({
      query: (device_id) => ({
        url: `/core/auth/2fa/devices/${device_id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TrustedDevices'],
    }),

    revokeAllDevices: builder.mutation<
      { success: boolean; revoked_count: number; message: string },
      void
    >({
      query: () => ({
        url: '/core/auth/2fa/devices',
        method: 'DELETE',
      }),
      invalidatesTags: ['TrustedDevices'],
    }),
  }),
});

export const {
  useVerifyCodeMutation,
  useResendCodeMutation,
  useGetTrustedDevicesQuery,
  useRevokeDeviceMutation,
  useRevokeAllDevicesMutation,
} = twoFactorApi;
